module.exports = "/src/views/player/help/images/clot2.jpg";